export default __webpack_public_path__ + "static/media/bag.d029575b.svg";